module.exports = __webpack_public_path__ + "static/media/semaphore.bdc05180.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/semaphore.png
// module id = 609
// module chunks = 0